import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { OpenEndedAnswerV1, OpenEndedAnswerV1DTO } from "./openEndedAnswerV1";
import { SingleChoiceAnswerV1, SingleChoiceAnswerV1DTO } from "./singleChoiceAnswerV1";
import { MultiChoiceAnswerV1, MultiChoiceAnswerV1DTO } from "./multiChoiceAnswerV1";
import { GridAnswerV1, GridAnswerV1DTO } from "./gridAnswerV1";
import { RankingAnswerV1, RankingAnswerV1DTO } from "./rankingAnswerV1";


export namespace GroupAnswerElementV1Enums {
  export namespace Answer {
    export interface OpenEndedDTO {
      case: string;
      openEndedAnswerAttributes: OpenEndedAnswerV1DTO;
    }
    
    export class OpenEnded {
      readonly isAnswerOpenEnded: boolean = true;
    
      readonly openEndedAnswerAttributes: OpenEndedAnswerV1;
    
    
      constructor(
      openEndedAnswerAttributes: OpenEndedAnswerV1
      ) {
        this.openEndedAnswerAttributes = openEndedAnswerAttributes;
      }
    
      static fromDTO(dto: OpenEndedDTO): OpenEnded {
        const openEndedAnswerAttributes = OpenEndedAnswerV1.fromDTO(getObject(dto, "openEndedAnswerAttributes", InvalidGroupAnswerElementV1AnswerOpenEndedOpenEndedAnswerAttributesError));
        return new OpenEnded(
          openEndedAnswerAttributes
        );
      }
    
      toDTO(): OpenEndedDTO {
        const dto: OpenEndedDTO = {
          case: "OPEN_ENDED",
            openEndedAnswerAttributes: this.openEndedAnswerAttributes.toDTO()
        };
        return dto;
      }
      }
    
    OpenEnded.prototype.toString = function toString(): string {
      return `Answer.OPEN_ENDED(openEndedAnswerAttributes='${this.openEndedAnswerAttributes}')`;
    };
    
    export interface SingleChoiceDTO {
      case: string;
      singleChoiceAnswerAttributes: SingleChoiceAnswerV1DTO;
    }
    
    export class SingleChoice {
      readonly isAnswerSingleChoice: boolean = true;
    
      readonly singleChoiceAnswerAttributes: SingleChoiceAnswerV1;
    
    
      constructor(
      singleChoiceAnswerAttributes: SingleChoiceAnswerV1
      ) {
        this.singleChoiceAnswerAttributes = singleChoiceAnswerAttributes;
      }
    
      static fromDTO(dto: SingleChoiceDTO): SingleChoice {
        const singleChoiceAnswerAttributes = SingleChoiceAnswerV1.fromDTO(getObject(dto, "singleChoiceAnswerAttributes", InvalidGroupAnswerElementV1AnswerSingleChoiceSingleChoiceAnswerAttributesError));
        return new SingleChoice(
          singleChoiceAnswerAttributes
        );
      }
    
      toDTO(): SingleChoiceDTO {
        const dto: SingleChoiceDTO = {
          case: "SINGLE_CHOICE",
            singleChoiceAnswerAttributes: this.singleChoiceAnswerAttributes.toDTO()
        };
        return dto;
      }
      }
    
    SingleChoice.prototype.toString = function toString(): string {
      return `Answer.SINGLE_CHOICE(singleChoiceAnswerAttributes='${this.singleChoiceAnswerAttributes}')`;
    };
    
    export interface MultiChoiceDTO {
      case: string;
      multiChoiceAnswerAttributes: MultiChoiceAnswerV1DTO;
    }
    
    export class MultiChoice {
      readonly isAnswerMultiChoice: boolean = true;
    
      readonly multiChoiceAnswerAttributes: MultiChoiceAnswerV1;
    
    
      constructor(
      multiChoiceAnswerAttributes: MultiChoiceAnswerV1
      ) {
        this.multiChoiceAnswerAttributes = multiChoiceAnswerAttributes;
      }
    
      static fromDTO(dto: MultiChoiceDTO): MultiChoice {
        const multiChoiceAnswerAttributes = MultiChoiceAnswerV1.fromDTO(getObject(dto, "multiChoiceAnswerAttributes", InvalidGroupAnswerElementV1AnswerMultiChoiceMultiChoiceAnswerAttributesError));
        return new MultiChoice(
          multiChoiceAnswerAttributes
        );
      }
    
      toDTO(): MultiChoiceDTO {
        const dto: MultiChoiceDTO = {
          case: "MULTI_CHOICE",
            multiChoiceAnswerAttributes: this.multiChoiceAnswerAttributes.toDTO()
        };
        return dto;
      }
      }
    
    MultiChoice.prototype.toString = function toString(): string {
      return `Answer.MULTI_CHOICE(multiChoiceAnswerAttributes='${this.multiChoiceAnswerAttributes}')`;
    };
    
    export interface GridDTO {
      case: string;
      gridAnswerAttributes: GridAnswerV1DTO;
    }
    
    export class Grid {
      readonly isAnswerGrid: boolean = true;
    
      readonly gridAnswerAttributes: GridAnswerV1;
    
    
      constructor(
      gridAnswerAttributes: GridAnswerV1
      ) {
        this.gridAnswerAttributes = gridAnswerAttributes;
      }
    
      static fromDTO(dto: GridDTO): Grid {
        const gridAnswerAttributes = GridAnswerV1.fromDTO(getObject(dto, "gridAnswerAttributes", InvalidGroupAnswerElementV1AnswerGridGridAnswerAttributesError));
        return new Grid(
          gridAnswerAttributes
        );
      }
    
      toDTO(): GridDTO {
        const dto: GridDTO = {
          case: "GRID",
            gridAnswerAttributes: this.gridAnswerAttributes.toDTO()
        };
        return dto;
      }
      }
    
    Grid.prototype.toString = function toString(): string {
      return `Answer.GRID(gridAnswerAttributes='${this.gridAnswerAttributes}')`;
    };
    
    export interface RankingDTO {
      case: string;
      rankingQuestionAttributes: RankingAnswerV1DTO;
    }
    
    export class Ranking {
      readonly isAnswerRanking: boolean = true;
    
      readonly rankingQuestionAttributes: RankingAnswerV1;
    
    
      constructor(
      rankingQuestionAttributes: RankingAnswerV1
      ) {
        this.rankingQuestionAttributes = rankingQuestionAttributes;
      }
    
      static fromDTO(dto: RankingDTO): Ranking {
        const rankingQuestionAttributes = RankingAnswerV1.fromDTO(getObject(dto, "rankingQuestionAttributes", InvalidGroupAnswerElementV1AnswerRankingRankingQuestionAttributesError));
        return new Ranking(
          rankingQuestionAttributes
        );
      }
    
      toDTO(): RankingDTO {
        const dto: RankingDTO = {
          case: "RANKING",
            rankingQuestionAttributes: this.rankingQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    Ranking.prototype.toString = function toString(): string {
      return `Answer.RANKING(rankingQuestionAttributes='${this.rankingQuestionAttributes}')`;
    };
    
  
    export type Answer = OpenEnded | SingleChoice | MultiChoice | Grid | Ranking;
  
    export type AnswerDTO = OpenEndedDTO | SingleChoiceDTO | MultiChoiceDTO | GridDTO | RankingDTO;
  
    export const fromDTO = (dto: AnswerDTO): Answer => {
      switch (dto.case) {
        case "OPEN_ENDED":
            return OpenEnded.fromDTO(dto as OpenEndedDTO);
        case "SINGLE_CHOICE":
            return SingleChoice.fromDTO(dto as SingleChoiceDTO);
        case "MULTI_CHOICE":
            return MultiChoice.fromDTO(dto as MultiChoiceDTO);
        case "GRID":
            return Grid.fromDTO(dto as GridDTO);
        case "RANKING":
            return Ranking.fromDTO(dto as RankingDTO);
        default:
          throw new InvalidGroupAnswerElementV1AnswerError(
              `Case ${dto.case} is not valid case of Answer.`
          );
      }
    };
  }
  
}
export interface GroupAnswerElementV1DTO {
  questionCode: CodeDTO;
  answer: GroupAnswerElementV1Enums.Answer.AnswerDTO;
}

export class GroupAnswerElementV1 {
  readonly isGroupAnswerElementV1GroupAnswerElementV1: boolean = true;

  readonly questionCode: Code;
  readonly answer: GroupAnswerElementV1Enums.Answer.Answer;


  constructor(
  questionCode: Code, 
  answer: GroupAnswerElementV1Enums.Answer.Answer
  ) {
    this.questionCode = questionCode;
    this.answer = answer;
  }

  static fromDTO(dto: GroupAnswerElementV1DTO): GroupAnswerElementV1 {
    const questionCode = Code.fromDTO(getObject(dto, "questionCode", InvalidGroupAnswerElementV1QuestionCodeError));
    const answer = GroupAnswerElementV1Enums.Answer.fromDTO(getObject(dto, "answer", InvalidGroupAnswerElementV1AnswerError));
    return new GroupAnswerElementV1(
      questionCode,
      answer
    );
  }

  toDTO(): GroupAnswerElementV1DTO {
    const dto: GroupAnswerElementV1DTO = {
        questionCode: this.questionCode.toDTO(),
        answer: this.answer.toDTO()
    };
    return dto;
  }
  }

GroupAnswerElementV1.prototype.toString = function toString(): string {
  return `GroupAnswerElementV1(questionCode='${this.questionCode}',answer='${this.answer}')`;
};

export class InvalidGroupAnswerElementV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1Error";
  }
}
export class InvalidGroupAnswerElementV1QuestionCodeError extends InvalidGroupAnswerElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1QuestionCodeError";
  }
}

export class InvalidGroupAnswerElementV1AnswerError extends InvalidGroupAnswerElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerError";
  }
}

export class InvalidGroupAnswerElementV1AnswerOpenEndedError extends InvalidGroupAnswerElementV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerOpenEndedError";
  }
}

export class InvalidGroupAnswerElementV1AnswerOpenEndedOpenEndedAnswerAttributesError extends InvalidGroupAnswerElementV1AnswerOpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerOpenEndedOpenEndedAnswerAttributesError";
  }
}

export class InvalidGroupAnswerElementV1AnswerSingleChoiceError extends InvalidGroupAnswerElementV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerSingleChoiceError";
  }
}

export class InvalidGroupAnswerElementV1AnswerSingleChoiceSingleChoiceAnswerAttributesError extends InvalidGroupAnswerElementV1AnswerSingleChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerSingleChoiceSingleChoiceAnswerAttributesError";
  }
}

export class InvalidGroupAnswerElementV1AnswerMultiChoiceError extends InvalidGroupAnswerElementV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerMultiChoiceError";
  }
}

export class InvalidGroupAnswerElementV1AnswerMultiChoiceMultiChoiceAnswerAttributesError extends InvalidGroupAnswerElementV1AnswerMultiChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerMultiChoiceMultiChoiceAnswerAttributesError";
  }
}

export class InvalidGroupAnswerElementV1AnswerGridError extends InvalidGroupAnswerElementV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerGridError";
  }
}

export class InvalidGroupAnswerElementV1AnswerGridGridAnswerAttributesError extends InvalidGroupAnswerElementV1AnswerGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerGridGridAnswerAttributesError";
  }
}

export class InvalidGroupAnswerElementV1AnswerRankingError extends InvalidGroupAnswerElementV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerRankingError";
  }
}

export class InvalidGroupAnswerElementV1AnswerRankingRankingQuestionAttributesError extends InvalidGroupAnswerElementV1AnswerRankingError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerElementV1AnswerRankingRankingQuestionAttributesError";
  }
}
